import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import axios from "axios";
import { logDev } from "../utils/logger.js";

const formatDateFr = (dateStr) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString("fr-FR", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric"
  });
};

const BoutonValiderEtVerrouiller = ({
  groupeId,
  periodePrivilegiee,
  periodeDominanteEffective,
  setPeriodeValidee,
  setGroupeActif,
  onReloadPériodes,
  setSnackbar,
  t,
  couleur,
  emoji,
  safePeriodes,
  setReloadTrigger,
  langue
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const periodeId = periodePrivilegiee || periodeDominanteEffective;
  const periodeObj = safePeriodes?.find(p => p._id === periodeId);

  const handleConfirm = async () => {
    try {
      logDev("🔒 Validation + verrouillage déclenchés", { groupeId, periodeId });

      const res = await axios.post(`${process.env.REACT_APP_API}/sondages/valider`, {
        groupe: groupeId,
        periodeDominante: periodeId,
        dateValidation: new Date().toISOString()
      });
      setPeriodeValidee(res.data.periodeId);

      await axios.put(`${process.env.REACT_APP_API}/groupes-admin/${groupeId}/verrouiller-sondage`);
      const updated = await axios.get(`${process.env.REACT_APP_API}/groupes/${groupeId}`);
      setGroupeActif(updated.data);

      setSnackbar({
        open: true,
        message: t("SurveyLocked"),
        severity: "success"
      });

      onReloadPériodes();
      if (setReloadTrigger) {
        setReloadTrigger(prev => prev + 1);
      }
      } catch (err) {
      logDev("❌ Erreur validation + verrouillage", {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data
      });

      setSnackbar({
        open: true,
        message: t("ErrorLockingSurvey"),
        severity: "error"
      });
    }
  };

  return (
    <>
      <Button
        variant="contained"
        disabled={!periodeId} // désactive si null
        onClick={() => setOpenConfirm(true)}
        sx={{
          backgroundColor: "#3399FF !important",
          color: "#fff",
          fontWeight: "bold",
          '&:hover': {
            backgroundColor: "#3399FF"
          }
        }}
      >
        ✅ {t("ValidateEndOfSurvey")}
      </Button>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>{t("ConfirmEndOfSurvey")}</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontWeight: "bold", color: couleur }}>
            {emoji} {t("MenuCreationFollowingWinningDates")}
          </Typography>

          <Typography sx={{ mt: 1 }}>
            <span style={{ fontWeight: "bold" }}>
              {periodePrivilegiee
                ? t("YouChooseSpecificPeriod")
                : t("NaturalDominantePeriodUsed")}
            </span>
          </Typography>

          {periodeObj?.start && periodeObj?.end && (
            <Typography sx={{ mt: 1, fontStyle: "italic" }}>
              {t("SelectedPeriod")} {formatDateFr(periodeObj.start)} {t("To")} {formatDateFr(periodeObj.end)}
            </Typography>
          )}

          <Typography sx={{ mt: 2 }}>{t("OktoGo")}</Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="inherit">
            {t("Cancel")}
          </Button>
          <Button
            onClick={() => {
              setOpenConfirm(false);
              handleConfirm();
            }}
            color="success"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BoutonValiderEtVerrouiller;
